import { useEffect, useState } from "react";

import type {
  ProjectLeadCompanionDock,
  ProjectLeadCompanionPosition,
} from "../projectLeadCompanionState";

export interface CompanionLayoutInput {
  readonly surface: "global" | "task-dialog";
  readonly dock: ProjectLeadCompanionDock;
  readonly position: ProjectLeadCompanionPosition | null;
}

export function companionUsableViewportHeight(input: CompanionLayoutInput): number {
  return input.surface === "task-dialog"
    ? Number.POSITIVE_INFINITY
    : typeof window === "undefined"
      ? 0
      : window.innerHeight;
}

export function companionFrameStyle(input: CompanionLayoutInput) {
  if (input.surface === "task-dialog") return undefined;
  return {
    left: input.dock === "floating" ? input.position?.x : undefined,
    top: input.dock === "floating" ? input.position?.y : undefined,
  };
}

export function companionPlacementClass(input: CompanionLayoutInput): string {
  if (input.surface === "task-dialog") return "relative h-full w-full";
  if (input.dock === "right") {
    return "top-14 right-3 bottom-3 w-[min(28rem,calc(100vw-1.5rem))]";
  }
  if (input.position !== null) {
    return "h-[min(42rem,calc(100dvh-5rem))] w-[min(27rem,calc(100vw-1.5rem))]";
  }
  return "right-4 bottom-4 h-[min(42rem,calc(100dvh-5rem))] w-[min(27rem,calc(100vw-1.5rem))]";
}

export function useProjectLeadCompanionPortal() {
  const [portal, setPortal] = useState<HTMLElement | null>(null);

  useEffect(() => {
    const findPortal = () =>
      setPortal(document.querySelector<HTMLElement>("[data-project-lead-companion-portal]"));
    findPortal();
    const observer = new MutationObserver(findPortal);
    observer.observe(document.body, { childList: true, subtree: true });
    return () => observer.disconnect();
  }, []);

  return portal;
}
